import Table from "react-bootstrap/Table";

import { timeToString } from "@/utils/dateUtil";
import { MedicalAttendanceTypeEnum } from "@/utils/enums/MedicalAttendanceTypeEnum";
import { ResumeGrouped } from "@/services/esus/attendanceService";
import { User } from "@/@types/sintegrada/User";

type Props = {
	aggregatedByProfessionalsAndMedicalAttendanceType: ResumeGrouped<
		User,
		ResumeGrouped<MedicalAttendanceTypeEnum, object>
	>[];
	averageTimeInSecondsByProfessional: ResumeGrouped<User, object>[];
};

export function AttendanceByProfessionalTable({
	aggregatedByProfessionalsAndMedicalAttendanceType,
	averageTimeInSecondsByProfessional,
}: Props) {
	return (
		<Table responsive striped bordered hover className="text-center">
			<thead>
				<tr className="fw-bolder">
					<th className="ps-2 text-start">Profissional</th>
					<th>Consultas</th>
					<th>Reavaliações</th>
					<th>Tempo médio de atendimento</th>
					<th className="pe-2 text-end">Total</th>
				</tr>
			</thead>
			<tbody>
				{aggregatedByProfessionalsAndMedicalAttendanceType.map(
					(professionalGroup, index) => (
						<tr key={`professional-medical-attendance-table-row-${index}`}>
							<td className="ps-2 text-start">
								{professionalGroup.key.name || "Não informado"}
							</td>
							<td>
								{(professionalGroup.values || [])
									.find(
										(attendanceTypeGroup) =>
											attendanceTypeGroup.key ===
											MedicalAttendanceTypeEnum.REQUESTED
									)
									?.total.toLocaleString() || 0}
							</td>
							<td>
								{(professionalGroup.values || [])
									.find(
										(attendanceTypeGroup) =>
											attendanceTypeGroup.key ===
											MedicalAttendanceTypeEnum.EVALUATED
									)
									?.total.toLocaleString() || 0}
							</td>
							<td>
								{timeToString(
									averageTimeInSecondsByProfessional.find(
										(a) => a.key.id === professionalGroup.key.id
									)?.total || 0
								)}
							</td>
							<td className="pe-2 text-end">
								{(professionalGroup.values || [])
									.map((attendanceTypeGroup) => attendanceTypeGroup.total)
									.reduce((acc, curr) => acc + curr, 0)
									.toLocaleString()}
							</td>
						</tr>
					)
				)}
			</tbody>
		</Table>
	);
}
